import type { Person } from '../api';
import { isNonEmptyString } from '../utils';

/** Retrieve a person full name */
export function getPersonFullName(person: Pick<Person, 'firstName' | 'middleName' | 'lastName'>): string {
  return [person.firstName, person.middleName, person.lastName].filter(isNonEmptyString).join(' ');
}